import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {createBlocks} from '../../../store/actions/blockActions';
import {convertToBlockEntity} from '../utils';
import {IState} from '../../../store/reducers';

export function useCreateBlocks(content: any): any {
  /*
   * Create blocks based on batchID, if no uid is present.
   * BatchID equals:
   * - now
   * - length of the blocks to create (so we know when to trigger onCreate)
   *
   * This hook is only available in the "parent" block
   */
  const reportBlocks = useSelector((state: IState) => state.reportForm.blocks);
  const dispatch = useDispatch();
  const uid = content.uid;

  useEffect(() => {
    if (!uid) {
      const {batchId} = content;
      const _blocks = reportBlocks?.filter((b: any) => b.batchId === batchId) || [];

      if (_blocks.length) {
        dispatch(createBlocks(_blocks.map((block: any) => convertToBlockEntity(block))));
      }
    }
  }, []);
}
